export default element => {
    var settings = { animation: 'fade', separator: ',', speed: 1000 };
    var current = 0;
    var words = [];
    var animations = ['fade', 'bounce', 'slide', 'zoom'];

    function init() {
        var keys = Object.keys(settings);
        for (var i = 0; i < keys.length; i++) {
            if (element.dataset[keys[i]]) {
                settings[keys[i]] = element.dataset[keys[i]];
            }
        }

        words = element.textContent.split(settings.separator).map(function (x) {
            return x.trim();
        });

        element.textContent = words[current];

        if (words.length <= 1)
            return;

        setInterval(rotate, settings.speed);
    }

    function rotate() {
        if (animations.indexOf(settings.animation) > -1) {
            element.style.opacity = 0;
            element.classList.remove(settings.animation);

            setTimeout(function () {
                return element.classList.add(settings.animation);
            }, 20);

            current = current === words.length - 1 ? 0 : current + 1;
            element.textContent = words[current];
        }
    }

    init();
};